import _extends from "@babel/runtime/helpers/extends";
import { WixDesignSystemProvider } from '@wix/design-system';
import React, { useEffect, useState } from 'react';
import { initBiLogger, reportInstallerInitiated } from './bi/bi';
import { v4 as uuidv4 } from 'uuid';
import { InstallerMainContextProvider } from './context/InstallerContext';
import { TranslationsContext } from './context/TranslationsContext';
import { getEnrichedTFunc } from './utils/getEnrichedTFunc';
import { ModalsAndWindowContextProvider } from './context/ModalsAndWindowContext';
import { ErrorHandlerProvider } from './components/ErrorBoundary/ErrorHandlerProvider';
import { PanoramaContextProvider } from './context/PanoramaContext';
import { AppWrapper } from './components/App/AppWrapper';
import { TRANSLATIONS_NAMESPACE } from '@wix/app-installer/internal-use';
export const AppInstallerContent = _ref => {
  let {
    tenantId: initialTenantId,
    essentials: {
      i18n,
      httpClient,
      platform
    },
    ...props
  } = _ref;
  const {
    panoramaClient,
    appId,
    tenantType,
    correlationId,
    silentInstall = false,
    avoidPostInstallation = false,
    onInstallationCompleted,
    onInstallationFailed,
    MarketingConsentContent,
    hideModalOverlay,
    version,
    pageId,
    isOneStepInstall
  } = props;
  const [installationId] = useState(() => uuidv4());
  const [tenantId, setTenantId] = useState(initialTenantId || '');
  useEffect(() => {
    initBiLogger({
      appId,
      tenantId,
      tenantType,
      platform,
      version,
      avoidPostInstallation,
      silentInstall,
      correlationId,
      installationId,
      isMarketingConsent: Boolean(MarketingConsentContent || isOneStepInstall),
      pageId
    });
    reportInstallerInitiated();
  }, []);
  const enrichedTFunc = getEnrichedTFunc(i18n);
  return /*#__PURE__*/React.createElement(WixDesignSystemProvider, {
    features: {
      newColorsBranding: true
    }
  }, /*#__PURE__*/React.createElement(PanoramaContextProvider, {
    panoramaClient: panoramaClient,
    appId: appId,
    tenantId: tenantId,
    installationId: installationId
  }, /*#__PURE__*/React.createElement(TranslationsContext.Provider, {
    value: {
      i18n,
      t: enrichedTFunc,
      ns: TRANSLATIONS_NAMESPACE
    }
  }, /*#__PURE__*/React.createElement(ModalsAndWindowContextProvider, {
    onInstallationCompleted: onInstallationCompleted,
    hideModalOverlay: hideModalOverlay
  }, /*#__PURE__*/React.createElement(ErrorHandlerProvider, {
    silentInstall: silentInstall,
    onInstallationFailed: onInstallationFailed
  }, /*#__PURE__*/React.createElement(InstallerMainContextProvider, _extends({}, props, {
    platform: platform,
    httpClient: httpClient,
    tenantId: tenantId,
    setTenantId: setTenantId
  }), /*#__PURE__*/React.createElement(AppWrapper, null)))))));
};
//# sourceMappingURL=AppInstallerContent.js.map